import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { api, ago } from "@/lib/api";

const REASONS = {
  profile_incomplete: "Add skills or target titles to your profile so we can find matches.",
  no_new_matches: "No new openings scored 50+ for your profile in the past 7 days. When that happens, no email is sent that week.",
};

export default function DigestPreview() {
  const [d, setD] = useState(null);
  const load = async () => { const { data } = await api.get("/email/digest/preview"); setD(data); };
  return (
    <div className="mt-4 rounded-xl border bg-slate-50 p-4" data-testid="digest-preview">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-medium">This week's digest</p>
        <Button size="sm" variant="outline" onClick={load} data-testid="digest-preview-button">Preview</Button>
      </div>
      {d && (
        <div className="mt-3 space-y-2 text-sm">
          {d.items.length === 0 ? <p className="text-muted-foreground" data-testid="digest-preview-empty">{REASONS[d.reason]}</p> : d.items.map((j) => (
            <Link key={j.job_id} to={`/app/jobs/${j.job_id}`} className="flex justify-between gap-3 hover:text-primary" data-testid={`digest-item-${j.job_id}`}>
              <span className="truncate">{j.title} · <span className="text-muted-foreground">{j.employer}</span></span><span className="font-mono">{j.score}</span>
            </Link>
          ))}
          <p className="text-xs text-muted-foreground">{d.enabled ? `Sent weekly. ${d.last_sent_at ? `Last checked ${ago(d.last_sent_at)}; the next one goes out 7 days after that.` : ""}` : "Turn the digest on above to get this by email once a week."}</p>
        </div>
      )}
    </div>
  );
}
